/**
 * Internal dependencies
 */
import connectionStatusActions from './connection-status';

const actions = {
	...connectionStatusActions,
};

export default actions;
